import { render } from "./UpdateWiFiSettings.vue?vue&type=template&id=32830348&scoped=true"
import script from "./UpdateWiFiSettings.vue?vue&type=script&lang=ts"
export * from "./UpdateWiFiSettings.vue?vue&type=script&lang=ts"

import "./UpdateWiFiSettings.vue?vue&type=style&index=0&id=32830348&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32830348"

export default script